<div class="wccard p-3 mb-1">
  <app-companypage-ai [requestaidata]="talentmovementAI" [currentCompanyName]="currentCompanyName" [insightstabname]="'talent movement'" [totalcount]="totalresultcount" ></app-companypage-ai>
</div>
<div class="wccard p-3 mb-2">
    <span *ngIf="dataAvailable?.hiresAndDepartures && (winningCompanyTrends?.length || loosingCompanyTrends?.length) && dataAvailable?.winningLosingTalent" [hidden]="!dataAvailable.winningLosingTalent">
      <p class="f-16 mb-6 font-weight-600">How have hires and departures trended over time?</p>
      <div>
          <fusioncharts
            height="450"
            width="100%"
            type="stackedcolumn2dline"
            [dataSource]="hireDepartureTalentDataSource"
          ></fusioncharts>
      </div>
    </span>
    <div *ngIf="!winningCompanyTrends?.length && !loosingCompanyTrends?.length">
      <div *ngIf="dataAvailable?.hiresAndDepartures">
        <p class="text-center small p-5 text-484b59">No Data Available</p>

      </div>


    </div>
         <div class="loader text-center" *ngIf="!dataAvailable?.winningLosingTalent">
        <img src="../../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
    </div>

</div>
<div class="wccard p-3 mb-1">
    <p class="f-16 mb-6 font-weight-600">Where is {{ company | titlecase }} winning and losing talent?</p>
    <span [hidden]="!dataAvailable.winningLosingTalent">
      <div class="row mb-3">
        <div class="col">
          <table class="w-100" mat-table matSort [dataSource]="winningLosingTalentDataSource" (matSortChange)="manualSort()">
            <ng-container matColumnDef="company">
              <th class="col-md-4 f-12 text-9696" mat-header-cell *matHeaderCellDef> {{tableHeaderObj['company']}} </th>
              <td mat-cell *matCellDef="let element">
                <div class="d-flex p-2">
                  <div style="width: 50px; border-right: 1px solid #eceff4;">
                    <span class="compnaylogoplaceholder" [ngClass]="{'logobgcolor':!element?.companylogo}">
                    <i class="fas fa-building f-12" *ngIf="!element?.companylogo"></i>
                    <img [src]="element?.companylogo" alt="element?.company" *ngIf="element?.companylogo">
                    </span>
                  </div>

                  <!-- <div class="text-484b59" style="margin-left: 24px;">{{ element.company | titlecase }} </div> -->

                  <p class="f-16 icon-color mb-1 f-14 position-relative" [ngClass]="{'companyHover': element?.website}">
                    <span class="" (mouseenter)="getCompanyInfo(element.company)">
                        <span class="position-relative text-capitalize"
                            [ngClass]="{'dstooltip pointer':element?.website, companyHover: element?.website}">
                            <div class="text-484b59" style="margin-left: 24px;">{{ element.company | titlecase }} </div>
                            <span class="dstooltip-content">
                                <app-company-hover-modal [companyInformation]="primaryCompanyInformation" *ngIf="primaryCompanyInformation"></app-company-hover-modal>
                            </span>
                        </span>
                    </span>
                </p>

                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="winningTalent">
              <th class="col-2 f-12 text-9696" mat-header-cell *matHeaderCellDef mat-sort-header> {{tableHeaderObj['winning']}} </th>
              <td class="col-2 text-484b59 font-weight-600" mat-cell *matCellDef="let element"> <span class="pointer" (click)="handelRedirection('winningtalent', element.company)">{{element.winningTalent | number }}</span> </td>
            </ng-container>

            <ng-container matColumnDef="losingTalent">
              <th class="col-2 f-12 text-9696" mat-header-cell *matHeaderCellDef mat-sort-header> {{tableHeaderObj['losing']}} </th>
              <td class="col-2 text-484b59 font-weight-600" mat-cell *matCellDef="let element"> <span class="pointer" (click)="handelRedirection('losingtalent', element.company)">{{element.losingTalent | number }}</span> </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="winningLosingTalentDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: winningLosingTalentDisplayedColumns;"></tr>
          </table>
            <div *ngIf="!winningLosingTalentDataSource?.data?.length">
              <p class="text-center small p-5 text-484b59">No Data Available</p>
          </div>
        </div>
      </div>
    </span>
    <div class="loader text-center" *ngIf="!dataAvailable?.winningLosingTalent">
      <img src="../../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
    </div>
</div>

<div class="d-flex justify-content-center wccard ng-star-inserted" *ngIf="totalCount > 10">
  <ngb-pagination [collectionSize]="25" [maxSize]="5" aria-label="Custom pagination" [pageSize]="pageSize" rotate="false" (pageChange)="setPage($event)" [(page)]="currentPage" [ellipses]="false"
   [boundaryLinks]="false"
  [directionLinks]="false">
  </ngb-pagination>
</div>
